<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl">Etat Poste Devis</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
      </search-filter>
      <div class="flex">
        <button v-if="isFinanceManager" class="btn-indigo py-2.5 mr-4 flex h-11 mt-7 items-center disabled:opacity-50" @click="confirmSelection" :disabled="selectedItems.length === 0">
          <div v-if="sending" class="btn-spinner mr-2"/>
          <span>Paiement confirmé</span>
        </button>
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-2 pt-6 pb-4 items-center text-center">N° Order</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">N° Devis</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">N° Facture</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">IMEI</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Agent</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Shop</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Etat</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Paiement</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Devis</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">facture</th>
          <th class="px-2 pt-6 pb-4 items-center text-center">Annuler</th>
        </tr>
        <tr v-for="repair in repairs.data" v-if="repair !== null" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100 cursor-pointer" >
          <td class="border-t">
            <div class="px-6 py-4 flex items-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="repair.id" v-model="selectedItems">
            </div>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center focus:text-indigo-500" >
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.quote_id }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.invoice_number }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.agent }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.shop }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.state }}
            </span>
          </td>
          <td class="border-t" @click="showForm(repair)">
            <span class="px-4 py-4 flex items-center" tabindex="-1">
              {{ repair.payed }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer le devis" @click="printQuote(repair.id)">
              <svg class="h-10 w-10 mx-auto text-indigo-600 hover:text-indigo-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Imprimer la facture" @click="printInvoice(repair.id)">
              <svg class="h-10 w-10 mx-auto text-green-600 hover:text-green-800" xmlns="http://www.w3.org/2000/svg" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Annuler le devis" @click="cancelQuote(repair)" :class="{ 'opacity-25': processing }">
              <svg class="h-10 w-10 mx-auto text-red-500 hover:text-red-600" :class="{'cursor-not-allowed opacity-25':!repair.canCancel }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
              </svg>
            </span>
          </td>
        </tr>
        <tr v-if="repairs.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No reparation found.</td>
        </tr>
      </table>
      <!-- Detail Modal -->
      <jet-dialog-modal max-width="4xl" :show="detailForm" @close="detailForm = false">
        <template #title>
          Detail
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <text-input v-model="activeRepair.imei" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="IMEI"/>
              <text-input v-model="activeRepair.created_at" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Date Reception"/>
              <text-input v-model="activeRepair.client" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Client"/>
              <text-input v-model="activeRepair.client_phone" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Telephone"/>
              <text-input v-model="activeRepair.model" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Model"/>
              <text-input v-model="activeRepair.brand" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Brand"/>
              <text-input v-model="activeRepair.malfunction" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Panne"/>
              <text-input v-model="activeRepair.tech_name" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Technicien"/>
              <text-input v-model="activeRepair.agency" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Agence"/>
              <text-input v-model="activeRepair.price" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="Prix"/>
              <text-input v-model="activeRepair.discount" disabled="disabled"  class="px-3 pb-6 w-full lg:w-1/4" label="Remise"/>
              <text-input v-model="activeRepair.price_ttc" disabled="disabled" class="px-3 pb-6 w-full lg:w-1/4" label="prix apres remise"/>
              <div class="px-3 pb-6 w-full lg:w-1/2">
                <textarea-input  v-model="activeRepair.comment" disabled="disabled" label="Commentaire"/>
              </div>
              <div class="px-3 pb-6 w-full lg:w-1/2">
                <textarea-input  v-model="activeRepair.client_comment" disabled="disabled" label="Commentaire client"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
        </template>
      </jet-dialog-modal>
    </div>
    <pagination v-if="repairs != null" :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";
import JetDialogModal from '@/Jetstream/DialogModal'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import TextInput from "@/Shared/TextInput"
import JetButton from '@/Jetstream/Button'
import TextareaInput from "@/Shared/TextareaInput"
import JetDangerButton from '@/Jetstream/DangerButton'

export default {
  metaInfo: {title: 'Etat poste'},
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
    JetDialogModal,
    JetSecondaryButton,
    TextInput,
    JetButton,
    TextareaInput,
    JetDangerButton
  },
  props: {
    repairs: Object,
    filters: Object,
    errors: Object,
    isFinanceManager: {
      default: false
    },
  },
  data() {
    return {
      detailForm: false,
      sending: false,
      processing: false,
      selectedItems: [],
      selectAll: false,
      activeRepair: {
        quote_id: null,
        imei: null,
        creation_date: null,
        client: null,
        client_phone: null,
        model: null,
        brand: null,
        malfunction: null,
        tech_name: null,
        agency: null,
        price: null,
        price_ttc: null,
        comment: null,
        client_comment: null,
      },
      quote: {
        quoteId: null,
        repairId: null,
        discount: null,
        priceAfterDiscount: 0,
      },
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('quote.status', Object.keys(query).length ? query : {remember: 'forget'}),{
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    showForm(repair) {
      this.detailForm = true
      this.activeRepair = repair
    },
    printQuote(id) {
      window.open(this.route('quote.print', id), "_blank");
    },
    printInvoice(id) {
      window.open(this.route('quote.print', id) + '?invoice=1', "_blank");
    },
    cancelQuote(repair) {
      if (!repair.canCancel) return

      this.quote.quoteId = repair.quote_id
      this.quote.repairId = repair.id
      const data = new FormData()
      data.append('quote', JSON.stringify(this.quote) || '')
      data.append('action', 'reject' || null)
      this.$inertia.post(this.route('quote.update'), data, {
        preserveScroll: true,
        onStart: () => this.processing = true,
        onFinish: () => this.processing = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            window.open(this.route('quote.print-bl', repair.id), "_blank");
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },

    select() {
      this.selectedItems = [];
      if (this.selectAll) {
        for (let i in this.repairs) {
          if (this.repairs.hasOwnProperty(i)) {
            this.selectedItems.push(this.repairs[i].id);
          }
        }
      }
    },
    confirmSelection() {
      if (!this.isFinanceManager) {
        alert('Vous n\'avez pas les droits pour effectuer cette action')
        return
      }
      const data = new FormData()
      data.append('ids', this.selectedItems || [])
      this.$inertia.post(this.route('quote.confirmPayment'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => {
          this.sending = false
          this.selectedItems = []
        }
      })
    }
  },
}
</script>
